import { z } from 'zod';

const SAFE_SEGMENT = '[A-Za-z0-9._-]{1,255}';

export function stagedFlowUploadPathSchema(dealId: string, packageId: string) {
  const pattern = new RegExp(
    `^${dealId}/${packageId}/[0-9a-f-]{36}/${SAFE_SEGMENT}$`
  );
  return z.string().regex(pattern, 'Invalid staged upload path');
}

export function extractFileNameFromStagedFlowUploadPath(
  storagePath: string
): string {
  const segments = storagePath.split('/');
  const fileName = segments[3];
  if (!fileName) {
    throw new Error('Invalid staged upload path');
  }
  return fileName;
}
